import {Injectable} from '@angular/core';
import {GlobalDataService} from '../../housekeeping/services/global-data.service';
import {GlobalVariable} from '../../../../app/config';

@Injectable()
export class ReportingService {
  public apiendpoint_url = GlobalVariable.FORDAPIEndPointURL;

  constructor(private _globalDataService: GlobalDataService) {
  }


  postUserIQandInterval(file, start, end, userFile, callback) {
    var payloadData = new FormData();
    if(userFile){
      payloadData.append("file", file);
    }
    payloadData.append("start", start);
    payloadData.append("end", end);
    payloadData.append("email", JSON.parse(localStorage.getItem('user')).username);
    if(userFile){
      this._globalDataService.PostAjaxMultipartCall(this.apiendpoint_url + "/lms/uploadFile2", payloadData, (result) => {
        console.log(result)
      })
    }else{
      this._globalDataService.PostAjaxMultipartCall(this.apiendpoint_url + "/lms/uploadFile3", payloadData, (result) => {
        console.log(result)
      })
    }

  }
  getActivityReport(start,end,id){
    this._globalDataService.GetAjaxCall(this.apiendpoint_url+"/lms/reporting/"+start+"/"+end+"/"+(id?id:0),(result) => {
      console.log(result)
    },true);
  }
  getOwnershipTrackingData(start, end, callback) {
    this._globalDataService.PostAjaxCall(this.apiendpoint_url + "/lms/owner/changeOwnerBulk/" + start + "/" + end+"/", (result) => {
      callback(result);
    }, true);
  }
  downloadFile(data: Response) {
    console.log(data);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/reporting/services/reporting.service.ts